module.exports = __webpack_public_path__ + "img/erin-patterson11.a807bd60.png";